// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetPromoCodeApplyBookingResponse

import { hydrateWidgetBookingPriceDiscount, type WidgetBookingPriceDiscount, type WidgetBookingPriceDiscountApiResponse } from './widgetBookingPriceDiscount.gen';

export type WidgetPromoCodeApplyBookingApiResponse = {
	success: boolean;
	code: string | null;
	discountAmount: WidgetBookingPriceDiscountApiResponse | null;
	error: string | null;
};

export type WidgetPromoCodeApplyBooking = {
	success: boolean;
	code: string | null;
	discountAmount: WidgetBookingPriceDiscount | null;
	error: string | null;
};

export function hydrateWidgetPromoCodeApplyBooking(data: WidgetPromoCodeApplyBookingApiResponse): WidgetPromoCodeApplyBooking {
	return {
		...data,
		discountAmount: data.discountAmount ? hydrateWidgetBookingPriceDiscount(data.discountAmount) : null,
	};
}